export default __webpack_public_path__ + "static/media/pdc_mobility_step3.12e3bd54.svg";